const indexData = [
  { label: '韩漫专区', desc: '韩国漫画精选合集', icon: 'ri-earth-fill', count: '800+部' },
  { label: '日漫专区', desc: '日本漫画经典大全', icon: 'ri-global-fill', count: '600+部' },
  { label: '国漫专区', desc: '国产漫画崛起之作', icon: 'ri-map-pin-fill', count: '500+部' },
  { label: '玄幻漫画', desc: '奇幻修真热血升级', icon: 'ri-magic-line', count: '320部' },
  { label: '恋爱漫画', desc: '甜蜜浪漫心动时刻', icon: 'ri-heart-line', count: '280部' },
  { label: '热血漫画', desc: '燃爆打斗竞技对决', icon: 'ri-fire-line', count: '260部' },
  { label: '新番推荐', desc: '每周新作速递', icon: 'ri-sparkling-line', count: '每周更新' },
];

export default function Index() {
  return (
    <section id="index" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-black text-foreground-950 mb-2">分类索引</h2>
          <p className="text-sm text-foreground-500">按类别快速找到你想看的漫画类型</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexData.map((item, i) => (
            <a
              key={i}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className={`group flex items-start gap-4 p-5 rounded-xl transition-all duration-200 no-underline ${
                i < 3
                  ? 'bg-background-50 hover:bg-background-200/70'
                  : 'bg-background-50 hover:bg-background-200/70'
              }`}
            >
              <div className={`w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0 ${
                i === 0 ? 'bg-primary-100' :
                i === 1 ? 'bg-accent-100' :
                i === 2 ? 'bg-secondary-100' :
                'bg-background-200'
              }`}>
                <i className={`${item.icon} text-lg ${
                  i === 0 ? 'text-primary-500' :
                  i === 1 ? 'text-accent-500' :
                  i === 2 ? 'text-secondary-500' :
                  'text-foreground-500'
                }`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="text-sm font-bold text-foreground-900 group-hover:text-primary-500 transition-colors">
                    {item.label}
                  </h3>
                  <span className="text-[10px] text-foreground-400 whitespace-nowrap">{item.count}</span>
                </div>
                <p className="text-xs text-foreground-500">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>

        <div className="flex flex-wrap justify-center gap-2 mt-6">
          {['悬疑', '搞笑', '奇幻', '校园', '重生', '穿越', '竞技', '美食', '治愈'].map((tag) => (
            <a
              key={tag}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="text-xs px-3 py-1 rounded-full bg-background-50 text-foreground-500 hover:text-primary-500 hover:bg-primary-50 transition-colors duration-200 no-underline whitespace-nowrap"
            >
              {tag}漫画
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}